import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import Modal from '../../../../../../../components/Modal';
import TextInput from '../../../../../../../components/TextInput';
import { formatPrice } from '@/utils/formatter';
import { updateExtra } from '../../../../../../../graphql/mutations';
import { Sheet } from '../../AllergenModal/styled';
import { Field } from '../../ProductEditModal/styled';
import Button from '../../../../../../../components/Button';
import AllergenModal from '../../AllergenModal';
import { InfoIcon } from '../../styled';
import { productCategories as productCategoriesMutation } from '../../../../../../../graphql/queries';
import i18n from '@/utils/i18n';

function ExtraEditModal({ productId, extra, storeId, onClose }) {
  const e = { ...extra, price: extra.price_raw || extra.price };
  const [values, setValues] = useState(e);
  const [isEditingExtras, setIsEditingExtras] = useState(false);
  const [updateExtraMutation, { loading: updating }] = useMutation(updateExtra);

  const touchedValues = useMemo(
    () =>
      Object.keys(values).reduce((touched, key) => {
        if (e[key] !== values[key]) return { ...touched, [key]: values[key] };
        return touched;
      }, {}),
    [e, values],
  );

  function handleChange({ target: { type, name, value } }) {
    const formattedValue = type === 'number' ? +value : value;
    setValues({ ...values, [name]: formattedValue });
  }

  function onAllergensModalClosed(newAllergens) {
    extra.allergens = newAllergens;
    setValues({ ...values, allergens: newAllergens });
    setIsEditingExtras(false);
  }

  function handleSave() {
    if (Object.keys(touchedValues).length) {
      updateExtraMutation({
        variables: {
          product_id: productId,
          extra_id: extra.extra_id,
          payload: { name: extra.name, price: extra.price, ...touchedValues },
        },
        refetchQueries: [
          {
            query: productCategoriesMutation,
            variables: {
              id: storeId,
              filter: 'ALL',
            },
          },
        ],
        update: () => {
          onClose();
        },
      });
    }
  }

  return (
    <Modal onClose={onClose}>
      <Sheet>
        <Field>
          <pre>{values.extra_id}</pre>
        </Field>
        <Field>
          <TextInput
            name="name"
            value={values.name}
            onChange={handleChange}
            placeholder={i18n.t('Menu:extraName')}
          />
        </Field>
        <Field>
          <TextInput
            name="price"
            value={values.price}
            onChange={handleChange}
            placeholder={`${i18n.t('Menu:extraPrice')}: ${formatPrice(
              values.price,
            )}`}
            type="number"
          />
        </Field>
        {isEditingExtras && (
          <AllergenModal
            parentProductId={productId}
            productId={extra.extra_id}
            allergens={extra.allergens}
            onClose={onAllergensModalClosed}
          />
        )}
        <Field>
          <InfoIcon name="info" onClick={() => setIsEditingExtras(true)} />
        </Field>
        <Button
          disabled={!Object.keys(touchedValues).length}
          loading={updating}
          onClick={handleSave}
        >
          {i18n.t('Menu:save')}
        </Button>
      </Sheet>
    </Modal>
  );
}

ExtraEditModal.propTypes = {
  productId: PropTypes.string.isRequired,
  extra: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  storeId: PropTypes.string.isRequired,
};

export default ExtraEditModal;
